import axios from "axios";
import { genKey, getStorage } from "./Storage";


export const lpad = (e, padString, length) => {
  let str = e.toString();

  while (str.length < length) {
    str = padString + str;
  }

  return str;
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || isNaN(phoneNumber)) return `input must be a number was sent ${phoneNumber}`;
  if (typeof (phoneNumber) !== 'string') phoneNumber = phoneNumber.toString();
  if (phoneNumber.length === 10) {
    return phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
  }
};

export const checkUserRight = (typeProfil, roleNeed) => {
  return !!roleNeed.includes(typeProfil.profil);
};

export const initAxios = (getValidToken, axios) => {
  let token = getValidToken();
  axios.defaults.headers.common = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
  axios.defaults.headers.delete = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
  axios.defaults.headers.get = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
  axios.defaults.headers.patch = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
  axios.defaults.headers.post = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
  axios.defaults.headers.put = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
}

export const formatError = (alert, err) => {
  alert.removeAll();
  if (err?.response?.data?.status) {
    alert.error(`[${err?.response?.data?.status} - ${err?.response?.data?.error}] ${err?.response?.data?.message}`);
  } else {
    alert.error(`Une erreur est survenue sur l'application, merci de vous rapprocher de l'administrateur`);
  }
}

export const getProfil = (role) => {
  switch (role) {
    case "ADMINISTRATEUR_TECHNIQUE":
      return 1;
    case "ADMINISTRATEUR_FONCTIONNEL":
      return 2;
    case "SUPERVISEUR":
      return 3;
    case "TECHNICIEN":
      return 4;
    default:
      return 4;
  }
}

// Récupération des données via les APIs ou le cache en fonction du statut du WebSocket
export const callAxios = async (wsStatus, cacheKey, axiosParam, setLoading, alert) => {

  // Affichage du spinner
  setLoading ? setLoading(true) : null;

  // Récupération des données via l'API
  if (wsStatus) {

    console.debug(`[callAxios] datas from API : ${JSON.stringify(axiosParam)}`);
    let res = await axios(axiosParam);
    setLoading ? setLoading(false) : null;

    if (res.status === 200) {
      return res.data;
    } else {
      formatError(alert, res);
      return [];
    }

  }

  // Récupération des données à partir du cache
  if (cacheKey) {
    console.debug(`[callAxios] datas from cache : ${genKey(cacheKey)}`);
    setLoading ? setLoading(false) : null;
    return getStorage(genKey(cacheKey));
  }

}